export default __webpack_public_path__ + "static/media/ic_dot.742d7626.svg";